export const REACTION_ORDER = ["👍", "❤️", "😂"];

export const sortReactions = (reactions) => {
  if (!reactions || typeof reactions !== "object") {
    return {};
  }

  const sorted = {};

  REACTION_ORDER.forEach((emoji) => {
    if (reactions[emoji]) {
      sorted[emoji] = reactions[emoji];
    }
  });

  Object.keys(reactions).forEach((emoji) => {
    if (!sorted[emoji]) {
      sorted[emoji] = reactions[emoji];
    }
  });

  return sorted;
};

export const applyOptimisticUpdates = (serverMessage, pendingReactions) => {
  if (!serverMessage || !pendingReactions) {
    return serverMessage;
  }

  const messagePending = pendingReactions[serverMessage.thread_id];
  if (!messagePending) {
    return {
      ...serverMessage,
      reactions: sortReactions(serverMessage.reactions),
    };
  }

  const updatedReactions = { ...serverMessage.reactions };

  Object.keys(messagePending).forEach((emoji) => {
    const emojiPending = messagePending[emoji];
    if (!emojiPending) return;

    if (!updatedReactions[emoji]) {
      updatedReactions[emoji] = { count: 0, users: {} };
    }

    const reactionData = { ...updatedReactions[emoji] };
    const users = { ...reactionData.users };
    let count = reactionData.count || 0;

    Object.keys(emojiPending).forEach((userId) => {
      const isAdding = emojiPending[userId];
      if (isAdding === true) {
        if (!users[userId]) {
          users[userId] = true;
          count++;
        }
      } else if (isAdding === false) {
        if (users[userId]) {
          delete users[userId];
          count--;
        }
      }
    });

    if (count > 0) {
      updatedReactions[emoji] = { count, users };
    } else {
      delete updatedReactions[emoji];
    }
  });

  return {
    ...serverMessage,
    reactions: sortReactions(updatedReactions),
  };
};

export const createOptimisticReactionUpdate = (
  message,
  emoji,
  userId,
  isAdding,
) => {
  const reactions = { ...message.reactions };

  if (!reactions[emoji]) {
    reactions[emoji] = { count: 0, users: {} };
  }

  const reactionData = { ...reactions[emoji] };
  const users = { ...reactionData.users };
  let count = reactionData.count || 0;

  if (isAdding) {
    if (!users[userId]) {
      users[userId] = true;
      count++;
    }
  } else {
    if (users[userId]) {
      delete users[userId];
      count--;
    }
  }

  if (count > 0) {
    reactions[emoji] = { count, users };
  } else {
    delete reactions[emoji];
  }

  return {
    ...message,
    reactions: sortReactions(reactions),
  };
};

export const shouldClearPendingReaction = (
  serverMessage,
  emoji,
  userId,
  isAdding,
) => {
  const serverReactions = serverMessage.reactions || {};
  const hasReactionInServer = serverReactions[emoji]?.users?.[userId] === true;

  if (isAdding && hasReactionInServer) {
    return true;
  }

  if (!isAdding && !hasReactionInServer) {
    return true;
  }

  return false;
};
